module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.91"},{"quantity":0.03,"color":"#91E3AD","label":"0.91 - 1.87"},{"quantity":0.06,"color":"#DEFFB0","label":"1.87 - 3.03"},{"quantity":0.01,"color":"#FFE68C","label":"3.03 - 4.11"},{"quantity":9,"color":"#FF9982","label":"4.11 - 5.94"},{"quantity":12,"color":"#FF4D30","label":"5.94 - 9.24"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/city_mme_1981_2016_lcr_90_rice.json
// module id = NXr0
// module chunks = 171